var _excluded = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
var StyledGridRow = /*#__PURE__*/styled.div.withConfig({
  displayName: "GridRow__StyledGridRow",
  componentId: "sc-1vg7jv6-0"
})(["display:flex;box-sizing:border-box;justify-content:space-between;margin:0 -", " 0;flex-direction:row;flex-wrap:wrap;"], function (_ref) {
  var theme = _ref.theme;
  return theme.spacing.sp8;
});
var GridRow = function GridRow(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledGridRow, rest, children);
};
GridRow.displayName = 'GridRow';
export default GridRow;